import { Metaverse, MetaverseNames } from 'types/Metaverse'

import GlobeIconSvg from 'assets/svg/icons-globe.svg'
import FallbackIcon from 'assets/svg/globe.png'
import decentralandIcon from 'assets/svg/icons-metaverses-decentraland.svg'
import robloxIcon from 'assets/svg/icons-metaverses-roblox.svg'
import UnityIcon from 'assets/svg/icons-metaverses-unity.svg'
import UnrealIcon from 'assets/svg/icons-metaverses-unreal-engine.svg'
import voxelsIcon from 'assets/svg/icons-metaverses-voxels.svg'
import { GlobeIcon } from 'assets/icons/GlobeIcon'

export const METAVERSE_ICON_BY_NAME = {
  '': GlobeIconSvg,
  Decentraland: decentralandIcon,
  Voxels: voxelsIcon,
  Roblox: robloxIcon,
  Unity: UnityIcon,
  'Unreal Engine': UnrealIcon,
}
export const METAVERSE_IMAGE_BY_NAME_FILTER = {
  '': <GlobeIcon />,
  'Decentraland-String-eq': <img src={decentralandIcon} alt="" />,
  'Voxels-String-eq': <img src={voxelsIcon} alt="" />,
  'Roblox-String-eq': <img src={robloxIcon} alt="" />,
  'Unity-String-eq': <img src={UnityIcon} alt="" />,
  'Unreal Engine-String-eq': <img src={UnrealIcon} alt="" />,
}
export const METAVERSE_IMAGE_BY_NAME = {
  '': <GlobeIcon />,
  Decentraland: <img src={decentralandIcon} alt="" />,
  Voxels: <img src={voxelsIcon} alt="" />,
  Roblox: <img src={robloxIcon} alt="" />,
  Unity: <img src={UnityIcon} alt="" />,
  'Unreal Engine': <img src={UnrealIcon} alt="" />,
}


export const getIconByMetaverse = (meta: Metaverse | MetaverseNames = '') => {
  if (typeof meta === 'string') {
    if (Object.hasOwn(METAVERSE_ICON_BY_NAME, meta)) {
      return (METAVERSE_ICON_BY_NAME )[meta]
    }
  } else {
    if (Object.hasOwn(METAVERSE_ICON_BY_NAME, meta.name)) {
      return (METAVERSE_ICON_BY_NAME)[meta.name]
    }
    if (meta.engine) {
      return (METAVERSE_ICON_BY_NAME)[meta.engine]
    }
  }
  return FallbackIcon
}
